<template lang="pug">
.vip-history-container(:class="{ 'ios-app': iOSAPP }")
  common-header.header(
    title="购买详情",
    color="#242729",
  )
  .body
    .card
      .top
        img.img(src="https://m.hellobike.com/resource/helloyun/15979/xXd46p-QyM.svg")
        .title 省钱会员
      .bottom
        ul.uls
          li
            .subtitle 支付金额
            .price ￥{{info.payPrice}}
          li
            .subtitle 交易时间
            .date {{info.createTime}}
          li
            .subtitle 交易编号
            .code {{info.orderNo}}
            .copy(
              data-clipboard-target=".code"
            ) 复制
</template>

<script>
import CommonHeader from '@/components/common-header';
import { env } from '@hb/NBridge/lib/h5';
import Clipboard from 'clipboard';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

const DEFAULT_INFO = () => ({
  goodsName: null,
  payPrice: null,
  createTime: null,
});

export default {
  components: {
    CommonHeader,
  },
  data() {
    return {
      iOSAPP: env.isIOS && env.isEasyBikeApp,
      info: DEFAULT_INFO(),
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.pageView({
      pageId: 'platform_PurchaseRecordsDetaile',
      categoryId: 'platform',
      businessInfo: {},
    });
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { query } = this.$route;

      if ('item' in query && !(typeof query.item === 'string')) {
        this.info = { ...this.info, ...query.item };
      }
      this.handlerCopy();
    },
    handlerCopy() {
      if (Clipboard) {
        const cb = new Clipboard('.copy');

        cb.on('success', (e) => {
          e.clearSelection();
          Toast.show('复制成功');
        });
      }
    },
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_PurchaseRecordsDetaile',
      categoryId: 'platform',
      businessInfo: {},
    });
    next();
  },
};
</script>

<style lang="less" scoped>
.fontstyle(@co: #242729, @lh: 0.22rem, @fs: 0.16rem, @fw: 400) {
  color: @co;
  line-height: @lh;
  font-size: @fs;
  font-weight: @fw;
}

.vip-history-container {
  height: 100vh;
  padding-top: 0.9rem;

  .ios-app {
    padding-top: 0.44rem;
  }

  .body {
    display: flex;
    flex-direction: column;
    padding: 0.16rem 0.12rem 0;
    background: #f7f9fa;
    min-height: 86.3vh;
  }

  .back {
    width: 0.24rem;
    height: 0.24rem;
  }

  .card {
    background: #fff;
    box-shadow: 0 0.01rem 0.04rem 0 rgba(0, 0, 0, 0.04);
    border-radius: 0.12rem;
    padding: 0.2rem 0.16rem 0.2rem 0.12rem;

    .top {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 0.17rem;
      border-bottom: 0.01rem solid #f0f3f5;

      .img {
        width: 0.4rem;
        height: 0.4rem;
      }

      .title {
        font-weight: 500;
        color: #242729;
        line-height: 0.22rem;
        font-size: 0.16rem;
        margin-left: 0.12rem;
      }
    }

    .bottom {
      padding-top: 0.16rem;

      .uls {
        list-style: none;

        > li {
          display: flex;
          justify-content: space-between;
          align-items: center;

          &:not(:first-child) {
            margin-top: 0.12rem;
          }

          .subtitle {
            .fontstyle(#879099);
          }

          .price,
          .date,
          .code,
          .copy {
            .fontstyle();
          }

          .copy {
            margin-left: 0.06rem;
            color: #08f;
          }

          .code {
            width: 65%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
